module.exports = __webpack_public_path__ + "static/img/xxx213.320a165.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xxx213.gif
// module id = dcdc
// module chunks = 2